// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__HAhR0","label":"button_label__9WuDF","button-primary-enabled":"button_button-primary-enabled__nIEED","button-disabled":"button_button-disabled__qYoLd"};